import axios from 'axios';
import * as constants from './../store/Constants';


export const axiosInstance = () =>{

  let authorization='';
  if(sessionStorage.getItem(constants.tokenName)){
    let user =  JSON.parse(sessionStorage.getItem(constants.tokenName));
    if ( user.data && user.data.token != null ) {
      authorization = `Bearer ${user.data.token}`;
    }
  }

  return axios.create({
    baseURL: document.getElementsByTagName('base')[0].getAttribute('href') + 'api/', 
    headers: {
      Authorization: authorization
    }
  });

}